export const DragItemTypes = {
    PRODUCT: 'product',
    OPTION: 'option',
  }

  export default DragItemTypes;